import { useMutation } from '@tanstack/react-query';
import { vehicleRepository } from '../../repositories/vehicle-repository';
import { IUpdateVehicle } from '../../interfaces/api-vehicle-interface';

export const usePatchVehicle = () =>
  useMutation((data: IUpdateVehicle) => vehicleRepository.update(data));
